// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_9r6","cls2":"ReferenceCard-cls2_F9D ReferenceCard-cls1_9r6"};